import Vue from 'vue'
// Компоненты связанные с корзиной
import CartModal from './components/cart/CartModal'
import CartModalNew from './components/cart/CartModalNew'
// Компоненты связанные с карточкой товара
import ProductCard from './components/product/product-card/ProductCard'
import Product from './views/product-page/Product'
import ProductCallback from './components/product/product-page/callback/ProductCallback'
// Компоненты связанные с аутентификацией пользователя
import AuthModal from './components/auth/AuthModal'
// Компоненты связанные с сравнением товара
import WhichToComparePopup from './components/product/product-comparison/WhichToComparePopup'
import Catalog from './views/Catalog'
import Advantages from './components/advantages/Advantages'
// Компонент кнопки чатов
import Chats from './components/chats/Chats'
// Компоненты геолокации
import GeoHeader from './components/user-geo/GeoHeader'
// Компоненты хедера
import HeaderMain from '@/components/header/HeaderMain'
import HeaderBonusesInfo from './components/header/HeaderBonusesInfo'
// Компонент оценки качества
import QualityControl from './views/quality-control-page/QualityControl'
// Компонент SEO
import FAQ from './components/faq/FAQ'
import Footer from './components/footer/Footer'
// import GdprPopup from '@/components/footer/GdprPopup.vue'
// Компонент модалки с уведомлением
import WarningModal from './components/helpers/WarningModal'
// Банер в категории
import CategoryBanner from './components/category/CategoryBanner'
// Category media block
import CategoryMedia from './components/category/CategoryMedia'
// Модалка геолокации
import GeoModal from './components/user-geo/GeoModal'
// Модалка UserType
import UserTypeModal from './components/header/user-type/UserTypeModal'
//  Галерея товаров
import ProductsSliderSkeleton from './components/product/product-block/ProductsSliderSkeleton'
import RenderedBlocks from './components/rendered-blocks/RenderedBlocks'
import ProductsSlider from './components/product/product-block/ProductsSlider'
// Доставка и оплата
import DeliveryAndPayment from './views/delivery-and-payment-page/DeliveryAndPayment'
import HeaderBanner from './components/header-banner/HeaderBanner'
// Карта
import VueMap from './components/map/VueMap'
import MapModal from '@/components/checkout/delivery/MapModal.vue'
// Страница магазины
import Shops from './views/shops-page/Shops'
// Страница сервисы
import Services from './components/services/Services'
// Логин ОТП
import LoginOtp from './components/manager-checkout/LoginOtp'
// Нижнее меню
import BottomMenu from './components/bottom-menu/BottomMenu'
// Слайдер отзывов
import ReviewsSlider from './components/reviews-slider/ReviewsSlider'
import HeaderUserType from './components/header/user-type/HeaderUserType'
import WelcomeBonusModal from './components/modals/WelcomeBonusModal'
import WelcomeFriendsModal from '@/components/modals/WelcomeFriendsModal'
import InfoMessage from './components/helpers/InfoMessage'
// Контент модал
import ContentModal from './components/promo-pages/ContentModal'
// Поп-ап с опросом
import QuestionnairePopup from './components/quality/QuestionnairePopup'
// Модалка отправки счета с личного кабинета (история заказов)
import SendBillModal from './components/cabinet/SendBillModal'
// Поп-ап отсутствующие товары в корзине
import PopupNotAvailableProducts from '@/components/checkout/popup-not-available-products/PopupNotAvailableProducts'
// Поп-ап быстрый заказ (резерв, предзаказ, быстрый заказ)
import QuickOrderModal from './components/product/quick-order/QuickOrderModal'
// Аккордеон
import { BaseAccordion, BaseAccordionItem } from '@/components/helpers/accordion'
// Модалка черной пятницы
import BlackFridayModal from '@/components/modals/BlackFridayModal'
// Страница Черной Пятницы
import BlackFriday from '@/views/landings/black-friday/Index'
// Кнопка купить
import BuyBtn from '@/components/cart/BuyBtn'
// Статистика по продуктам
import ProductsStats from '@/components/promo-pages/ProductsStats'
import CountdownLine from '@/components/promo-pages/CountdownLine'
// Большой блок товара
import ProductHeroBlock from '@/components/promo-pages/ProductHeroBlock'
// Лендинг программа лояльности
import LoyaltyProgram from '@/views/landings/loyalty-program/LoyaltyProgram'
// 404
import ErrorPage from '@/views/error-page/ErrorPage'
// Страница категории
import CategoryPage from '@/views/category-page/CategoryPage'
// Блок обратный звонок от эксперта
import ExpertCallback from '@/components/product/expert-callback/ExpertCallback'
// Хочете бути в курсі всіх новин і знижок?
import NewYearCallback from '@/components/rendered-blocks/NewYearCallback'
// Регистрация инструментов
import ToolsRegistration from '@/views/tools-registration/ToolsRegistration'
import ToolRepairRegistration from '@/components/forms/ToolRepairRegistration.vue'
import CopyToClipboardButton from '@/components/helpers/CopyToClipboardButton'
import CategoryRelatedSlider from '@/components/category/CategoryRelatedSlider.vue'
import ToolRepairRegistrationResultModal from '@/components/modals/ToolRepairRegistrationResultModal.vue'
import ResultModal from '@/components/modals/ResultModal.vue'
// Модальне вікно для вибору типу сортування результату пошуку
import SortingModal from '@/components/search-page/SortingModal'
import TranslationReport from '@/components/translation-report/TranslationReport.vue'
import HeroSlider from '@/components/sliders/HeroSlider.vue'
import DeliveryLocation from '@/components/header/DeliveryLocation.vue'
import CityLocationModal from '@/components/modals/CityLocationModal.vue'
import HeroSliderNew from '@/components/sliders/HeroSliderNew.vue'
import ImportantItems from '@/components/sliders/ImportantItems.vue'
import HeaderContacts from '@/components/header/HeaderContacts'

const globalComponents = [
  HeroSliderNew,
  HeaderContacts,
  ImportantItems,
  MapModal,
  CityLocationModal,
  DeliveryLocation,
  CategoryRelatedSlider,
  TranslationReport,
  HeroSlider,
  CartModal,
  CartModalNew,
  ProductCard,
  Product,
  ProductCallback,
  AuthModal,
  WhichToComparePopup,
  Catalog,
  Advantages,
  Chats,
  GeoHeader,
  HeaderMain,
  QualityControl,
  FAQ,
  Footer,
  // GdprPopup,
  WarningModal,
  CategoryBanner,
  GeoModal,
  UserTypeModal,
  ProductsSliderSkeleton,
  RenderedBlocks,
  ProductsSlider,
  DeliveryAndPayment,
  HeaderBanner,
  VueMap,
  Shops,
  Services,
  LoginOtp,
  BottomMenu,
  ReviewsSlider,
  HeaderUserType,
  WelcomeBonusModal,
  WelcomeFriendsModal,
  InfoMessage,
  ContentModal,
  QuestionnairePopup,
  SendBillModal,
  PopupNotAvailableProducts,
  QuickOrderModal,
  HeaderBonusesInfo,
  BaseAccordion,
  BaseAccordionItem,
  BlackFridayModal,
  BlackFriday,
  BuyBtn,
  ProductsStats,
  CountdownLine,
  ProductHeroBlock,
  LoyaltyProgram,
  ErrorPage,
  CategoryPage,
  ExpertCallback,
  NewYearCallback,
  ToolsRegistration,
  CopyToClipboardButton,
  ToolRepairRegistration,
  ToolRepairRegistrationResultModal,
  ResultModal,
  SortingModal,
  CategoryMedia
]

globalComponents.forEach(component => Vue.component(component.name, component))
